import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Feature, Point } from 'geojson';

@Injectable({
  providedIn: 'root'
})
export class HeuristicService {

  heuristicResultUrl = `${environment.serverBaseUrl}/heuristic/result/`;

  constructor(private http:HttpClient) { }
  
  getHeuristicResult(guards: number, interzone: number, intrazone: number, maxRouteInterzone: number, maxRouteIntrazone: number) {
    return this.http.get(this.heuristicResultUrl, {params: {guards, interzone, intrazone, maxRouteInterzone, maxRouteIntrazone}});
  }

  /**
  * Busca o resultado da heurística para um dado array de viaturas e de ocorrências.
  * @param patrolCars Lista de objetos contendo as posições das viaturas
  * @param events Lista de objetos contendo as posições das ocorrências
  */
  getHeuristicResultForLists(
    patrolCarsCoordinates: number[][],
    eventsCoordinates: number[][],
    date: string,
    hour: string,
    finalHour: string) {
    let body = {
      patrolCarsCoordinates,
      eventsCoordinates,
      date,
      hour,
      finalHour
    };
    return this.http.post(this.heuristicResultUrl, body);
  }
}
